<template>
  <div>
    <div class="maintitle">{{title}}</div>
    <el-divider></el-divider>
    <el-row class="text-left" :gutter="10">
      <el-button type='success' size='mini' @click="addDiv=true">添加新报备</el-button>
    </el-row>
    <el-table :data="list" row-key="id" border :stripe='true'>
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" inline class="demo-table-expand">
            <el-form-item label="地址">
              <span>{{ props.row.address}}</span>
            </el-form-item>
            <el-form-item label="上次小记时间">
              <span>{{ props.row.xiaojitime }}</span>
            </el-form-item>
            <el-form-item label="下次小记时间">
              <span>{{ props.row.lasttime }}</span>
            </el-form-item>
            <el-form-item label="有效期">
              <span>{{ props.row.outtime }}</span>
            </el-form-item>
            <el-form-item label="报备来源">
              <span>{{ formatSource(props.row.source) }}</span>
            </el-form-item>
            <el-form-item label="意向度">
              <span>{{ formatYixiang(props.row.yixiang) }}</span>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column label="公司名" :formatter="formatCompany"></el-table-column>
      <el-table-column label="联系电话" width='120'>
        <template slot-scope="scope">
          <span v-html='formatTel(scope.row.tel)'></span>
        </template>
      </el-table-column>
      <el-table-column prop="contact" label="联系人" width='80'></el-table-column>
      <el-table-column label="报备业务">
        <template slot-scope="scope">
          <span v-html='formatType(scope.row.type)'></span>
        </template>
      </el-table-column>
      <el-table-column :formatter="formatStatus" label="状态" width='100'></el-table-column>
      <el-table-column label="操作" width='80'>
        <template slot-scope="scope">
          <el-button type='text' @click="mdfy(scope)" v-if='scope.row.status == 0'>改</el-button>
          <el-button type='text' @click="showTichu(scope)">踢</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination background :current-page="page" :page-sizes="pagesizes" :page-size="pagesize" @size-change="handleSizeChange" @current-change="handleCurrentChange" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
    <el-dialog :visible.sync="addDiv" :show-close="false" :close-on-click-modal="false" @closed="resetFormInfo">
      <el-form :model="baobeiinfo" :rules="rules" ref="baobeiinfo">
        <el-form-item label="公司名称" :label-width="formLabelWidth" prop="company" required>
          <el-input v-model="baobeiinfo.company" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="联系人" :label-width="formLabelWidth" prop="contact" required>
          <el-input v-model="baobeiinfo.contact" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="联系电话" :label-width="formLabelWidth" prop="tel" required>
          <el-input v-model="baobeiinfo.tel" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="公司地址" :label-width="formLabelWidth" prop="address" required>
          <el-input v-model="baobeiinfo.address" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="报备业务" :label-width="formLabelWidth" prop="type" class="text-left" required>
          <el-select v-model="baobeiinfo.type" filterable :default-first-option='true' multiple style="width:500px" @change="checkType">
            <el-option v-for='item in typelist' :key='item.id' :value="item.id" :label='item.name'></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="行业" :label-width="formLabelWidth" prop="hangye" class="text-left" required>
          <el-select v-model="baobeiinfo.hangyeid" filterable :default-first-option='true'>
            <el-option v-for='item in hangyelist' :key='item.id' :value="item.id" :label='item.hangye'></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="客户来源" :label-width="formLabelWidth" prop="source" class="text-left" required>
          <el-select v-model="baobeiinfo.source">
            <el-option v-for='item in sourcelist' :key='item.id' :value="item.id" :label='item.source'></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="意向度" :label-width="formLabelWidth" prop="yixiang" class="text-left" required>
          <el-select v-model="baobeiinfo.yixiang">
            <el-option v-for='item in yixianglist' :key='item.id' :value="item.id" :label='item.yixiang'></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注" :label-width="formLabelWidth" prop="beizhu">
          <el-input v-model="baobeiinfo.beizhu" auto-complete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addDiv = false">取 消</el-button>
        <el-button type="primary" @click="submdfy">确 定</el-button>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="tichuDiv" :show-close="false" :close-on-click-modal="false" width="50%">
      <el-form>
        <el-form-item class="text-left" label="踢出原因" :label-width="formLabelWidth">
          <el-select class="margin-big-left" v-model="yuanyin" placeholder="请选择踢出原因">
            <el-option v-for="(item,index) in yuanyinlist" :key="index" :label="item.reason" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="tichuDiv = false;yuanyin=''">取 消</el-button>
        <el-button type="primary" @click="pushGonghai">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [], //员工列表
      title: "",
      range: "personal",
      keyType: "info",
      addDiv: false,
      baobeiinfo: {
        id: "",
        company: "",
        contact: "",
        tel: "",
        address: "",
        source: "",
        yixiang: "",
        beizhu: "",
        hangyeid: "",
        type: "",
      },
      tempinfo: {},
      page: 1,
      total: 0,
      departmentlist: JSON.parse(sessionStorage.getItem("departmentlist")),
      sourcelist: JSON.parse(sessionStorage.getItem("sourcelist")),
      yixianglist: JSON.parse(sessionStorage.getItem("yixianglist")),
      hangyelist: JSON.parse(sessionStorage.getItem("hangyelist")),
      typelist: JSON.parse(sessionStorage.getItem("typelist")),
      statuslist: JSON.parse(sessionStorage.getItem("statuslist")),
      tichuDiv: false,
      crntBaobei: "",
      keyword: "",
      slctdep: "",
      yuanyin: "",
      yuanyinlist: JSON.parse(sessionStorage.getItem("yuanyinlist")),
      rules: {
        // title: [
        //   { required: true, message: "请输入菜单名称", trigger: "blur" },
        //   { min: 2, message: "长度不能小于两个汉字", trigger: "blur" }
        // ],
        // model: [{ required: true, message: "请输入模块名称", trigger: "blur" }],
        // controller: [
        //   { required: true, message: "请输入控制器名称", trigger: "blur" }
        // ],
        // action: [{ required: true, message: "请输入方法名称", trigger: "blur" }]
      },
    };
  },
  methods: {
    handleSizeChange(size) {
      this.pagesize = size;
      this.page = 1;
      this.getlist();
    },
    handleCurrentChange(p) {
      this.page = p;
      this.getlist();
    },
    getlist() {
      this.$axios({
        url: this.HOST + "/baobei/baobei/list",
        method: "post",
        data: {
          keyword: this.keyword,
          page: this.page,
          pagesize: this.pagesize,
          range: this.range,
          slctdep: this.slctdep,
          keytype: this.keyType,
        },
      }).then((res) => {
        if (res.data.status == 1) {
          this.list = res.data.list.data;
          this.total = res.data.list.total;
        }
      });
    },
    formatSource(source) {
      for (let item in this.sourcelist) {
        if (this.sourcelist[item].id == source) {
          return this.sourcelist[item].source;
        }
      }
      return "未知";
    },
    formatYixiang(yixiang) {
      for (let item in this.yixianglist) {
        if (this.yixianglist[item].id == yixiang) {
          return this.yixianglist[item].yixiang;
        }
      }
      return "未知";
    },
    formatType(type) {
      let temp = [];
      for (let i in type) {
        for (let item in this.typelist) {
          if (this.typelist[item].id == type[i]) {
            temp.push(this.typelist[item].name);
          }
        }
      }
      return temp.join('<br />');
    },
    formatCompany(row){
      let date = new Date();
      let now = date.getTime();
      date = new Date(row.lasttime);
      let end = date.getTime();
      if((end-now)>86400000*this.warndays){
        return row.company;
      }else{
        return '<p class="text-danger">'+row.company+'</p>';
      }
    },
    formatTel(tel){
      let temp = tel.split(';');
      return temp.join('<br />');
    },
    formatStatus(row){
      for (let item in this.statuslist) {
        if (this.statuslist[item].id == row.status) {
          return this.statuslist[item].status;
        }
      }
      return "未知";
    },
    //重置菜单编辑对话框内容
    resetFormInfo() {
      for (let item in this.baobeiinfo) {
        this.baobeiinfo[item] = this.tempinfo[item];
      }
    },
    mdfy(scope) {
      this.crntBaobei = scope;
      for (let item in this.baobeiinfo) {
        this.baobeiinfo[item] = scope.row[item];
      }
      this.addDiv = true;
    },
    checkType() {
      if (this.baobeiinfo.type.length > 3) {
        this.$message({
          type: "warning",
          message: "报备业务不能超过3种",
        });
        this.baobeiinfo.type.splice(3, this.baobeiinfo.type.length - 3);
      }
    },
    submdfy() {
      // console.log(this.baobeiinfo);
      // return;
      this.$axios({
        url: this.HOST + "/baobei/baobei/add",
        method: "post",
        data: {
          info: this.baobeiinfo,
        },
      }).then((res) => {
        if (res.data.status == 1) {
          this.addDiv = false;
          this.getlist();
        }
      });
    },
    showTichu(scope) {
      this.crntBaobei = scope;
      this.tichuDiv = true;
    },
    pushGonghai() {
      // let scope = this.crntBaobei;
      this.$confirm(
        "确定要将" + this.crntBaobei.row.company + "踢入公海吗？本操作不可恢复",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      ).then(() => {
        this.$axios({
          url: this.HOST + "/baobei/baobei/tichu",
          method: "post",
          data: {
            id: this.crntBaobei.row.id,
            yuanyin: this.yuanyin,
          },
        }).then((res) => {
          if (res.data.status == 1) {
            this.$message({
              type: "info",
              message: res.data.info,
            });
            this.list.splice(this.crntBaobei.$index, 1);
            this.tichuDiv = false;
            this.yuanyin = "";
          }
        });
      });
    },
  },
  created: function () {
    this.title = this.$route.meta.title;
    for (let item in this.baobeiinfo) {
      this.tempinfo[item] = this.baobeiinfo[item];
    }
    this.getlist();
  },
};
</script>
<style>
.demo-table-expand {
  font-size: 0;
}
.demo-table-expand label {
  width: 120px;
  color: #99a9bf;
  text-align: right !important;
}
.demo-table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 50%;
}
</style>